export const bigWins = [
  {
    id: 1,
    player: 'Андрей К.',
    casino: 'Flagman',
    game: 'Lightning Roulette',
    amount: '4850000₽',
    multiplier: 'x500',
    date: '12 декабря 2025',
    bet: '9700₽'
  },
  {
    id: 2,
    player: 'Михаил С.',
    casino: 'IRWIN',
    game: 'Crazy Time',
    amount: '8200000₽',
    multiplier: 'x20000',
    date: '8 декабря 2025',
    bet: '410₽'
  },
  {
    id: 3,
    player: 'Екатерина Д.',
    casino: 'Martin',
    game: 'Monopoly Live',
    amount: '3100000₽',
    multiplier: 'x1000',
    date: '5 декабря 2025',
    bet: '3100₽'
  },
  {
    id: 4,
    player: 'Владимир П.',
    casino: 'STARDA',
    game: 'Mega Ball',
    amount: '2750000₽',
    multiplier: 'x100',
    date: '1 декабря 2025',
    bet: '27500₽'
  },
  {
    id: 5,
    player: 'Наталья В.',
    casino: 'Fugu',
    game: 'Lightning Blackjack',
    amount: '1980000₽',
    multiplier: 'x25',
    date: '28 ноября 2025',
    bet: '79200₽'
  },
  {
    id: 6,
    player: 'Сергей М.',
    casino: 'LEX',
    game: 'Deal or No Deal',
    amount: '5600000₽',
    multiplier: 'x500',
    date: '25 ноября 2025',
    bet: '11200₽'
  }
];